import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import Skeleton from '../../../../common/skeleton/index';
const GenericSkeleton = () => {
  return (
    <>
      <Card className="plan-info-card">
        <Row>
          <Col>
            <Skeleton count={7} className="plan-details-skeleton" />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default GenericSkeleton;
